@if (menuItems$ | async; as menus) {
  @for (menu of menus; track menu.name) {
    <a class="btn btn-primary w-100 mb-3" [routerLink]="menu.route">{{
      translationService.translateMenu(menu.name)
    }}</a>
  }
}
